import { genericConstants } from '../constants';

export const addDataCaptureIdentification = (data) => {
    return {
        type: genericConstants.ADD_IDENTIFICATION_DATA_SUCCESS,
        payload: data,
    };
};

export const addTitleLegoCurrent = (data) => {
    return {
        type: genericConstants.ADD_TITLE_LEGO_CURRENT_SUCCESS,
        payload: data,
    };
};

export const setDefaultLanguageAction = (data) => {
    return {
        type: genericConstants.SET_DEFAULT_LANGUAGE,
        payload: data,
    };
};